import * as React from "react"
import Flink from '~/components/shared/flink'
import { usePost } from '~/contexts/PostContext'
import { jnstyls, notBlank, imgSize } from '~/utils/helpers'

import QuickCaption from './quick-caption'

import { solid_btn } from "~/styles/app.module.scss"
import * as styles from "~/styles/blog/blog-copy-img.module.scss"
import * as bstyle from "~/styles/blog/blog.module.scss"


const possible_png = (url) => {
  return imgSize(url,500)
}

const BlogCopy = ({ blockId, index, add_h1, collblocks=false }) => {
  const { post, props } = usePost()
  const { quickProds } = props
  
  const block = post.data.blocks.find(x => x.id === blockId)
  const { settings } = block

  const align_class = notBlank(settings.align) ? `align_${settings.align}` : false
  const mob_align = notBlank(settings.mobile_align) ? `alignmob_${settings.mobile_align}` : false
  const has_copy = notBlank(settings.rawcopy) || notBlank(settings.copy) || notBlank(settings.copy_cta_link)

  let page_styles = ''

  if (notBlank(settings.title) && settings.title?.includes('The Mexican')) page_styles += `@media only screen and (min-width: 800px) {
      .title${index} {
        font-size: 4em;
      }
    }
    @media only screen and (max-width: 800px) {
      .title_img${index}  {
          max-height: 2em;
      }
      .title${index} {
        font-size: 9.5vw;
        margin-bottom: 0.75em;
      }
    }
    .title${index} span {
      display: block;
      font-size: 0.5em;
    }`
  if (notBlank(settings.desk_titleimg_height)) page_styles += `@media only screen and (min-width: 800px) {
      .title_img${index} {
        max-height: ${settings.desk_titleimg_height};
      }
    }`
  if (notBlank(settings.mobile_titleimg_height)) page_styles += `@media only screen and (max-width: 800px) {
      .title_img${index} {
        max-height: ${settings.mobile_titleimg_height};
      }
    }`
  if (notBlank(settings.title_align)) page_styles += `@media only screen and (min-width: 800px) {
      .title${index} {
        text-align: ${settings.title_align};
        opacity: 1;
      }
    }`
  if (notBlank(settings.mobi_title_align)) page_styles += `@media only screen and (max-width: 800px) {
      .title_img${index} {
        text-align: ${settings.mobi_title_align};
        opacity: 1;
      }
    }`

  if (has_copy) page_styles += `@media only screen and (min-width: 800px) {
      .text${index} {
        max-width: ${settings.textscale}%;
        text-align: ${settings.textalign};
      }
      .text${index} .copy_cta${index} {
        text-align: ${settings.textalign};
      }
    }
    @media only screen and (max-width: 800px) {
      .text${index} {
        text-align: ${settings.mobile_align};
      }
      .text${index} .copy_cta${index} {
        text-align: ${settings.mobile_align};
      }
    }`

  if (block.id === 1262) page_styles += `@media only screen and (min-width: 800px) {
      [block="1262"] .title_img${index} {
        max-height: unset;
        width: 20%;
      }
    }
    @media only screen and (max-width: 819px) {
      [block="1262"] .title_img${index} {
        max-height: unset;
        width: 70%;
      }
    }
  `

  if (block.id === 1813) page_styles += `
    {
      [block="1813"] .title1 {
        font-size: 2.75em;
        font-family: "big-caslon-fb", serif;
        text-transform: none;
        letter-spacing: 0.06em;
        font-weight: normal;
        margin-bottom: 1.5rem;
      }
    }
    @media only screen and (max-width: 819px) {
      [block="1262"] .title1 {
        font-size: 2.5em;
      }
    }
  `

  let classes = [bstyle.sec, styles.copy_block]
  if (align_class) classes.push(styles[align_class])
  if (mob_align) classes.push(styles[mob_align])
  if (settings.top_margin) classes.push(styles.nomargin)
  if (collblocks) classes.push(styles.collblock)

  if (notBlank(settings.capt_font)) classes.push(bstyle[`use_${settings.capt_font}`])

  const ctalink_styles = () => {
    return [settings.title === 'A LIMITED COLLECTION' ? solid_btn : settings.copy_cta_btn ? bstyle.cta_btn : bstyle.cta_link]
  }

  return (
    <div 
      className={jnstyls(classes)}
      block={block.id}
    >
      {notBlank(page_styles) && (<style dangerouslySetInnerHTML={{ __html: page_styles}} />)}
      
      {(index < 2 && add_h1) ? (
        <>
          {notBlank(settings.title_img) && (
            <h1 
              className={jnstyls([bstyle.title, styles.title, `title${index}`])}
              blg-mex={settings.title?.includes('The Mexican') ? '' : undefined}
              style={{marginBottom: !!has_copy ? ' ' : '0'}}
            >
              <img 
                className={jnstyls([bstyle.title_image, `title_img${index}`])}
                src={possible_png(settings.title_img)}
                alt={settings.title}
                height={100} width={400}
              />
            </h1>
          )}
          {(!notBlank(settings.title_img) && notBlank(settings.title)) && (
            <h1 
              className={jnstyls([bstyle.title, styles.title, `title${index}`])}
              blg-mex={settings.title?.includes('The Mexican') ? '' : undefined} 
              style={{marginBottom: !!has_copy ? ' ' : '0'}}
              dangerouslySetInnerHTML={{ __html: settings.title }}
            />
          )}
        </>
      ) : (
        <>
          {notBlank(settings.title_img) && (
            <h2 
              className={jnstyls([bstyle.title, styles.title])} 
              style={{textAlign: settings.textalign, marginBottom: !!has_copy ? ' ' : '0'}}
            >
              <img 
                className={jnstyls([bstyle.title_image, `title_img${index}`])}
                src={possible_png(settings.title_img)}
                alt={settings.title}
                height={100} width={400}
              />
            </h2>
          )}
          {(!notBlank(settings.title_img) && notBlank(settings.title)) && (
            <h2 
              className={jnstyls([bstyle.title, styles.title])} 
              style={{textAlign: settings.textalign, marginBottom: !!has_copy ? ' ' : '0'}}
              dangerouslySetInnerHTML={{ __html: settings.title }}
            />
          )}
        </>
      )}

      {has_copy && (
        <>
          <div className={jnstyls([styles.text, `text${index}`])}>
            {notBlank(settings.rawcopy) ? (
              <>
                {(settings.rawcopy?.includes('/products/') && quickProds.length > 0) ? (
                  <QuickCaption 
                    copy={settings.rawcopy} 
                    styles={''}
                  />
                ) : (
                  <div dangerouslySetInnerHTML={{ __html: settings.rawcopy }} />
                )}
              </>
            ) : (
              <>
                {(settings.copy?.includes('/products/') && quickProds.length > 0) ? (
                  <QuickCaption 
                    copy={settings.copy} 
                    styles={''}
                  />
                ) : (
                  <div dangerouslySetInnerHTML={{ __html: settings.copy }} />
                )}
              </>
            )}
        
            {notBlank(settings.copy_cta_link) && (
              <div className={jnstyls([styles.copy_cta, `copy_cta${index}`])} style={{textAlign: settings.textalign}}>
                <Flink 
                  href={settings.copy_cta_link}
                  className={jnstyls(ctalink_styles())}
                >
                  {notBlank(settings.copy_cta_image) ? (
                    <img 
                      className={styles.cta_img}
                      src={possible_png(settings.copy_cta_image)}
                      alt={settings.copy_cta_text}
                      height={100} width={400}
                    />
                  ) : (
                    <>
                      {settings.copy_cta_text}
                    </>
                  )}
                </Flink>

                {notBlank(settings.copy_cta2_link) && (
                  <Flink 
                    href={settings.copy_cta_link2}
                    className={jnstyls(ctalink_styles())}
                  >
                    {settings.copy_cta2_text}
                  </Flink>
                )}
              </div>
            )}
          </div>
        </>
      )}
    </div>
  )
}

export default BlogCopy

